export const getUrl = () => new URL(window.location.href);

export const getSearchParams = () => {
    const url = getUrl();

    return new URLSearchParams(url.search);
};
